import {
  getLocalizedDateFilter,
  getLocalizedQuoteStatus,
  getLocalizedSorting,
} from '../translations/default'

// The commented filters below are present on the Quote class,
// but have not been added as a filter to the API (yet)
export const QuoteFilter = {
  // productName: 'filter[productName.icontains]',
  quoteDateGreaterEqual: 'filter[quoteCreationDate.gte]',
  quoteDateLessEqual: 'filter[quoteCreationDate.lte]',
  quoteNumber: 'filter[number.icontains]',
  searchQuery: 'search[query]',
  // salesRep: 'filter[salesRepName.icontains]',
  sort: 'sort',
  status: 'filter[displayStatus.equals]',
  // updatedDateGreaterEqual: 'filter[lastUpdateDate.gte]',
  // updatedDateLessEqual: 'filter[lastUpdateDate.lte]',
  // user: 'filter[user.icontains]',
}

export const quoteFilterTranslationMap = {
  quoteDate: getLocalizedDateFilter,
  sort: getLocalizedSorting,
  status: getLocalizedQuoteStatus,
  updated: getLocalizedDateFilter,
}

export type QuoteFilters = typeof QuoteFilter
export type QuoteFilterKey = keyof QuoteFilters
export type QuoteFilterFnKey = keyof typeof quoteFilterTranslationMap

export const quoteFilterDefaults = {
  page: '1',
  sort: '-quoteCreationDate',
}

export interface QuoteFilterLabel {
  id: QuoteFilterKey
  label: string
}
